import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { CITIES_DATA } from "@/data/citiesData";

export const CitiesSection = () => (
  <section data-testid="cities-section" className="py-20 lg:py-24">
    <div className="container-x">
      <motion.div
        initial={{ y: 24 }}
        whileInView={{ y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-brand-primary mb-4">
          Service Areas
        </p>
        <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tighter leading-none text-zinc-900">
          Cities We Serve
        </h2>
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="origin-left mt-5 h-1 w-20 rounded-full bg-gradient-to-r from-[#8C6D1F] via-[#D4AF37] to-[#E9C767]"
        />
      </motion.div>

      <div className="mt-10 flex flex-wrap gap-3">
        {CITIES_DATA.map((c) => (
          <Link
            key={c.slug}
            to={`/service-areas/${c.slug}/`}
            data-testid={`cities-link-${c.slug}`}
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-white border border-zinc-200 text-sm font-semibold text-zinc-800 transition-all duration-200 hover:-translate-y-0.5 hover:border-[#D4AF37]/60 hover:shadow-[0_8px_30px_rgba(212,175,55,0.18)]"
          >
            <MapPin className="w-4 h-4 text-[#D4AF37]" />
            {c.name} &amp; Surroundings
          </Link>
        ))}
      </div>
    </div>
  </section>
);
